import { render, staticRenderFns } from "./EraserIndicator.vue?vue&type=template&id=13264a79&scoped=true&"
import script from "./EraserIndicator.vue?vue&type=script&lang=ts&"
export * from "./EraserIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./EraserIndicator.vue?vue&type=style&index=0&id=13264a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13264a79",
  null
  
)

export default component.exports